import React, { Fragment } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { themeActions } from "../../store/index";
import Button from "../UI/Button";
import "./MainNavigation.css";

const MainNavigation = (props) => {
    const isToken = localStorage.getItem('token');
    const history = useHistory();
    const dispatch = useDispatch();
    const isActivated = useSelector(state => state.theme.isActivated);
    const bgColor = useSelector(state => state.theme.bgColor);
    const logoutHandler = (e) => {
        e.preventDefault();
        localStorage.removeItem('token');
        localStorage.removeItem("email");
        history.replace("/login");
        window.location.reload();
    }
    const switchHandler = (e) => {
        e.preventDefault();
        dispatch(themeActions.changeTheme());
    }
    return (
        <Fragment>
            <div className={bgColor === false ? "header" : "header-negative"}>
                <ul className="header-list">
                    <li>
                        <NavLink to="/home">Home</NavLink>
                    </li>
                    {isToken !== null && <li>
                        <NavLink to="/profile">Profile</NavLink>
                    </li>}
                    <li>
                        <NavLink to="/about">About Us</NavLink>
                    </li>
                    {isToken == null && <li>
                        <NavLink to="/signup">Sign Up</NavLink>
                    </li>}
                    {isToken == null && <li>
                        <NavLink to="/login">Login</NavLink>
                    </li>}
                    {isToken !== null && <li>
                        <Button onClick={logoutHandler} className="logout">Logout</Button>
                    </li>}
                    {isActivated === true && <li>
                        <Button onClick={switchHandler} className="btn-toggle">Toggle</Button>
                    </li>}
                </ul>
            </div>
        </Fragment >);
}

export default MainNavigation;